export default {
  about: null,
  privacy_policy: null,
  terms_conditions: null
}